import { Component, h, Host, State } from '@stencil/core';
import { FirebaseService } from '../../utils/firebase';
import { customer } from '../../store/customer.store';
import { closeAccountFlow } from '../../modals/account.modal';


@Component({
  tag: 'tambr-account-modal',
  styleUrl: 'tambr-account-modal.css',
  shadow: true,
})
export class TambrAccountModal {

  @State() tab: string = 'activity';

  close() { closeAccountFlow(); } 
  
  async logout() { await FirebaseService.auth.signOut(); }

  render() {
    return (
      <Host id='tambr-account' class='tambr-modal-window large'>
        <div class='tambr-modal-header'>
          <tambr-icon type='close' class='close-button' onClick={ () => this.close() } />
        </div>

        <div class='tambr-modal-title'>Account</div>

        { this.renderGreeting() }

        { this.renderTabs() }

        <div class='tambr-modal-body'>{ this.renderTabContent() }</div>
      </Host>
    );
  }

  renderGreeting() {
    if (customer.platformCustomer) {
      return (
        <div class='tambr-modal-logout'>
          <div>Hi, {customer.platformCustomer.firstName}</div>
          <div class='tambr-modal-logout-link' onClick={this.logout}>Log out</div>        
        </div>
      )
    }
  }

  renderTabs() {
    return (
      <div class='account-wrapper__tabs'>

        <div class={ this.tab == 'activity' ? 'account-wrapper__tabs__active' : '' } 
          onClick={ () => this.tab = 'activity' }>Activity</div>
          
        <div class={ this.tab == 'wallet' ? 'account-wrapper__tabs__active' : '' }
          onClick={ () => this.tab = 'wallet' }>Wallet</div>

        <div class={ this.tab == 'account' ? 'account-wrapper__tabs__active' : '' }
          onClick={ () => this.tab = 'account' }>Account Info</div>
          
      </div>
    )
  }

  renderTabContent() {
    switch (this.tab) {
      case 'activity': return ( <tambr-account-activity /> );
      case 'wallet': return (<tambr-account-wallet />);
      case 'account': return ( <tambr-account-info /> );
    }
  }

}
